import { useState, useEffect } from 'react';
import { DEVICE_SCREENS, DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import ArrowSVG from '../../public/img/arrow.svg';

export function UpButton({
  elementId,
  screenCount = 1,
  mobileScreenCount = 2,
}: {
  elementId?: string;
  screenCount?: number;
  mobileScreenCount?: number;
}) {
  const [showButton, setShowButton] = useState(false);

  const scrollUp = () => {
    window.scrollTo(0, 0);
  };

  const checkScroll = () => {
    const isMobile = window.innerWidth < DEVICE_SCREENS.md;
    const screenHeight = document.documentElement.clientHeight;
    let isShowButton = false;

    if (isMobile) {
      isShowButton = window.scrollY > mobileScreenCount * window.innerHeight;
    } else {
      const element = elementId ? document.getElementById(elementId) : null;
      isShowButton = element
        ? element.getBoundingClientRect().top <= 100
        : window.scrollY > screenCount * screenHeight;
    }
    setShowButton(isShowButton);
  };

  useEffect(() => {
    window.addEventListener('scroll', checkScroll);

    return () => {
      window.removeEventListener('scroll', checkScroll);
    };
  }, []);

  return (
    <div>
      {showButton && (
        <button
          css={{
            width: 42,
            height: 42,
            borderRadius: '100%',
            border: '3px solid #F44336',
            position: 'fixed',
            bottom: '10%',
            right: '10%',
            background: '#fff',
            zIndex: 100,
            cursor: 'pointer',
            svg: {
              fill: '#F44336',
            },
            ':hover': {
              background: '#DA3226',
              borderColor: '#DA3226',
              opacity: 0.7,
              svg: {
                fill: '#fff',
              },
            },
            ':active': {
              background: '#C61A0D',
              borderColor: '#C61A0D',
              opacity: 0.7,
              svg: {
                fill: '#fff',
              },
            },
            [DEVICE_SCREENS_MAX_STRING.md]: {
              right: 8,
              bottom: 60,
            },
          }}
          type='button'
          onClick={scrollUp}
        >
          <ArrowSVG />
        </button>
      )}
    </div>
  );
}
